import React from 'react';

function About() {
  return (
    <>
      {/* Section 1: Image */}
      <section className="about">
        <div className="about-page">
          <img src="/images/We Are Experts in Building Dreams.png" alt="dreams" />
        </div>
      </section>

     <section className="about-info">
  <div className="about-info-container">
    {/* Who We Are Section */}
    <div className="about-box1">
      <h4 className="section-label">Who We Are</h4>
      <h2 className="section-heading">Who We Are</h2>
      <p>
        At Aman Chikan Handicraft, we are keepers of a legacy rooted in the rich cultural heritage of Lucknow. 
        What began as a boutique dedicated to the art of Chikankari has grown into a trusted name in handcrafted fashion. 
        Since stepping into manufacturing in 2005, we’ve combined tradition with innovation — preserving centuries-old embroidery 
        techniques while adapting to modern aesthetics. Every piece we create reflects our commitment to authenticity, quality, 
        and timeless elegance. From daily wear to festive ensembles, we bring Chikan craftsmanship to life — stitch by stitch, story by story.
      </p>
      <img src="/images/Rectangle 4502.png" alt="img"></img>
    </div>

    {/* Why Us Section */}
    <div className="about-box2">
      <h4 className="section-label">Why Us</h4>
      <h2 className="section-heading">Why Us</h2>
      <p>
        At Aman Chikan Handicraft, we don’t just sell garments — we deliver a legacy of craftsmanship, authenticity, and care. 
        Each piece is meticulously hand-embroidered by skilled artisans, ensuring unmatched quality and attention to detail. 
        With over two decades of experience, in-house manufacturing, and a deep respect for tradition, we offer designs that 
        blend cultural richness with contemporary elegance. From personalized styling to custom orders, our commitment to 
        customer satisfaction makes us a trusted choice for those who value timeless fashion and handcrafted excellence.
      </p>
      <img src="/images/Rectangle 4503.png" alt="img"></img>
    </div>
  </div>
</section>
<section class="fashion3">
  <div class="fashion3-header">
    <h2>Drape the Essence of <br /> Royalty</h2>
    <p>Crafting Outfits That Leave a <br />Timeless Impression</p>
  </div>

  <div class="fashion3-grid1">
    
    <div class="fashion3-card1">
      <img src="/images/picture111.png" alt="Ready Outfits"/>
      <h3>Kurti Sets</h3>
      <p>Handcrafted elegance in every thread. Featuring straight, A-line, and flared styles, paired with palazzo or pants — perfect for everyday grace or festive charm. Each piece tells a story of traditional artistry meeting contemporary sophistication.</p>
    </div>

    
    <div class="fashion3-card1">
      <img src="/images/picture2.png" alt="Customization"/>
      <h3>Customization</h3>
      <p>Your style, your way. From size adjustments to color choices and personalized designs — we tailor every Chikankari piece to fit you perfectly. Experience the luxury of bespoke fashion where every stitch reflects your unique personality and preferences.</p>
    </div>

    <div class="fashion3-card1">
      <img src="/images/picture3.png" alt="Fabric Material"/>
      <h3>Fabric Material</h3>
      <p>A wide range of breathable and elegant fabrics — cotton, georgette, mulmul, chiffon, and more — each handpicked to complement Chikankari embroidery beautifully. Premium materials that ensure comfort, durability, and timeless appeal in every garment.</p>
    </div>
  
    <div class="fashion3-card1">
      <img src="/images/Rectangle 4499.png" alt="Semi Stitched"/>
      <h3>Semi Stitched</h3>
      <p>Perfectly flexible and easy to customize. Our semi-stitched Chikankari pieces gives you freedom to tailor the fit while enjoying the charm of authentic hand embroidery .</p>
    </div>
  </div>
</section>

    </>
  );
}

export default About;
